import { render, staticRenderFns } from "./jobWantedInfo.vue?vue&type=template&id=0504ecbc&scoped=true&"
import script from "./jobWantedInfo.vue?vue&type=script&lang=js&"
export * from "./jobWantedInfo.vue?vue&type=script&lang=js&"
import style0 from "./jobWantedInfo.vue?vue&type=style&index=0&id=0504ecbc&prod&lang=scss&"
import style1 from "./jobWantedInfo.vue?vue&type=style&index=1&id=0504ecbc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0504ecbc",
  null
  
)

export default component.exports